import angular from 'angular';

import BaseMap from './map';
import CaseModel from './case';
import AccountModel from './account';
import AccountMap from './account-map';

function CaseMapFactory(Case, BaseMap, CurrentAccount, AccountMap) {
  return class CaseMap extends BaseMap {
    constructor() {
      super(Case);
      this.setApi('/cases', null, {
        get: {
          method: 'GET',
          url: '/cases',
          success: [data => {
            CurrentAccount.setData(data.accounts.current);
            AccountMap.fromCollection(data.accounts.others);
            this.fromCollection(data.cases);
          }]
        },
        getPublic: {
          method: 'GET',
          url: '/cases',
          params: {
            isPublic: true
          },
          success: [() => {}]
        }
      });
    }
  }
}
CaseMapFactory.$inject = ['Case', 'BaseMap', 'CurrentAccount', 'AccountMap'];

export default angular.module('maps.case', [CaseModel, BaseMap, AccountModel,
    AccountMap
  ])
  .factory('CaseMapFactory', CaseMapFactory)
  .service('CaseMap', ['CaseMapFactory', CaseMapFactory => new CaseMapFactory()])
  .name;


// WEBPACK FOOTER //
// ./project/models/case-map.js